<div class="message-card blue-fill mb-3">
    <mwp-text-translate text="A selected benefit requires payment information." jsonKey="usaEPayNote" />
</div>
<mwp-usa-e-pay-form [usaEPay]="usaEPay" [isWizardForm]="true" (emitContinue)="submit($event)" />